module.exports = __webpack_public_path__ + "media/images/info-11393b7a0d9ca3c7e9e0d8ed554e46e7.svg";